export const getAlbumUrl = (album: Album | null | undefined): string => {
	const slug = (album?.name ?? '').replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase()

	const number = album?.number ?? ''

	return `/browse/m/album/${slug}_${number}`
}

export const getComposerUrl = (composer: Composer): string =>
	`/browse/m/composer/${composer.name
		.replace(/[^a-zA-Z0-9]+/g, '-')
		.toLowerCase()}_${composer.id}`

export const getTrackUrl = (track: Track): string =>
	`/browse/m/track/${track.title
		.replace(/[^a-zA-Z0-9]+/g, '-')
		.toLowerCase()}_${track.id}`
